import { Invite } from '@/domain/swing/taxi/Invite';

export default function TaxiInvite() {
  return <Invite />;
}